import { useEffect, useState } from 'react';

/**
 * Shared trailing-edge debounce for search-as-you-type inputs. Every
 * keystroke-driven fetch in the app should go through this hook so one
 * consistent delay governs all typeaheads: the CLW cell lookup pickers (TTD
 * geo / audiences, GT taxonomy), list-page searches (folders, pacing, QA,
 * media plans), and the copy-workflow campaign search.
 *
 * Returns the value as it stood `delayMs` after the last change; the timer
 * restarts on every change, so a burst of keystrokes emits only the final
 * term. The immediate value stays available to the caller (state itself) for
 * instant UI feedback — only the FETCH should key off the debounced value.
 */
export const TYPEAHEAD_DEBOUNCE_MS = 300;

export function useDebouncedValue(value, delayMs = TYPEAHEAD_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
